module.exports = __webpack_public_path__ + "img/01宋雷.d4249082.png";